import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.95, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterLabel = ({ number, label }) => (
  <Reveal>
    <div className="flex items-center gap-4" data-testid={`chapter-label-${number}`}>
      <span className="font-display italic text-[#38BDF8] text-lg">{number}</span>
      <span className="h-px w-12 bg-[#38BDF8]/40" />
      <span className="text-[11px] tracking-[0.35em] uppercase text-slate-400">{label}</span>
    </div>
  </Reveal>
);

export const Blue = ({ children }) => (
  <span className="text-[#38BDF8]">{children}</span>
);
